module.exports = __webpack_public_path__ + "img/Weapon_172.6b60e5d7.png";